import { formatCopy } from "../../../theme/copy";
import { Rating } from "@mui/material";
import { useThemeContext } from "../../../globalContext/global-context";
import { starDividerStyle, starIconStyle } from "./style";

type DiscreteScaleStarsProps = {
  points: readonly { value: number }[];
  selectedValue: number | string | null | undefined;
  onSelect: (value: number) => void;
  testId: string;
  name: string;
  ariaLabel: string;
  disabled?: boolean;
  spread?: boolean;
  showDividers?: boolean;
};

export const DiscreteScaleStars = ({
  points,
  selectedValue,
  onSelect,
  testId,
  name,
  ariaLabel,
  disabled,
  spread = false,
  showDividers = false,
}: DiscreteScaleStarsProps) => {
  const { globalObject } = useThemeContext();
  const theme = globalObject.themeData.normalizedTheme;
  const primaryColor = theme.tokens.color.action.primary;
  const selectedIndex = points.findIndex(
    (point) => point.value === selectedValue,
  );

  return (
    <Rating
      data-testid={testId}
      name={name}
      aria-label={ariaLabel}
      emptyLabelText={theme.copy.labels.emptyRating}
      getLabelText={(value) =>
        formatCopy(
          value === 1 ? theme.copy.labels.star : theme.copy.labels.stars,
          { value },
        )
      }
      max={points.length}
      value={selectedIndex < 0 ? 0 : selectedIndex + 1}
      disabled={disabled}
      onChange={(_, index) => {
        if (index !== null) onSelect(points[index - 1].value);
      }}
      sx={{
        ...starIconStyle({ maxStars: points.length, theme }),
        ...(spread
          ? {
              width: "100%",
              display: "flex",
              "& > label": {
                flex: "1 1 0",
                display: "flex",
                justifyContent: "center",
              },
              "& > label.MuiRating-pristine": {
                flex: "0 0 0",
                width: 0,
              },
            }
          : {}),
        ...starDividerStyle(theme, showDividers),
      }}
      slotProps={{ icon: { sx: { color: primaryColor } } }}
    />
  );
};
